import React, { useState } from "react";
import "../styles/Blog.css";

// Import images (update with your blog images)
import image1 from "../assets/Prinz_Susan.jpg";
import image2 from "../assets/MiloHomepageSpiegel.jpeg";
// import image3 from "../assets/MiloHomepageSpiegel.jpeg";

import Header from "../components/Header";
import ContactModal from "../components/ContactModal";

const blogPosts = [
    {
        id: 1,
        title: "Über Mich",
        date: "Januar 24, 2026",
        author: "Susanne",
        excerpt: "Die Liebe zu Tieren wurde mir sprichwörtlich in die Wiege gelegt.",
        content: `
                <p className="text-gray-800 leading-relaxed mb-6">
Die Liebe zu Tieren wurde mir sprichwörtlich in die Wiege gelegt. Bereits als kleines Mädchen war ich immer von Tieren umgeben – und das prägt einen für das ganze Leben. Mein treuester Begleiter in den ersten Jahren war ein wunderschöner Amerikanischer Collie Rüde in der seltenen Tricolor-Färbung namens „Prinz“.</p>
<p>Meine Kindheit verbrachte ich stets dort, wo Tiere waren: sei es auf dem Bauernhof der Nachbarn, im Pferdestall einer Freundin meiner Mutter, im Wildtierpark oder sogar bei den Maikäfern, die vom Kirschbaum in unserem Garten fielen.</p>
<p>1988 zog ich in meine erste eigene Wohnung, begleitet von zwei Katzen. Mein Traum von einem Hund wurde 1997 wahr: Eine Mischlingshündin namens Sally kam in mein Leben.</p>
<p>Später folgten „Charly“, der Border Collie, und „Joy“, die Australian Cattle Dog Hündin meines Ex-Manns. 2010 begann ich unter dem Zwingernamen „Chocolate Chips“ Britisch Kurzhaar Katzen zu züchten.</p>
<p>Milo, ein Mix aus Boxer und Old English Bulldog, war mein Seelenhund. Er begleitete mich durch alle Höhen und Tiefen des Lebens. 2021 musste ich mich von Minnie verabschieden. Kurz danach zog Mabel, eine Amerikanische Collie Hündin, ein, und 2023 folgte Mathilda.</p>
<p>Am 23. Februar 2024 musste ich mich von Milo verabschieden. Sein Verlust hinterlässt eine riesige Lücke, doch die Erinnerung an ihn und all die wundervollen Tiere bleibt für immer.</p>
</div>

        `,
        image: image1,
    },

{
        id: 2,
        title: "Der „Vorzeigehund“ - Ein Symptom unserer Zeit",
        date: "Januar 16, 2026",
        author: "Netzfund",
        excerpt: "Unbewusste Wünsche, Leistungsdruck und die Falle des 'perfekten' Hundes",
        content: `
            
                <p>Es gibt kaum ein Thema, dass so still zerstörerisch wirkt und doch in kaum einem Hundeleben fehlt:
                Die unbewussten Erwartungen, die Menschen an ihre Hunde stellen.</P>

                <p>Was wie Liebe wirkt, ist manchmal Projektion.<br>
                Was wie Fürsorge aussieht, ist oft Kontrolle.<br>
                Und was wir „Erziehung“ nennen, dient nicht selten dazu, eigene Unsicherheiten zu kaschieren.</p>

                <p>Viele Hunde zerbrechen nicht an Krankheit, falscher Ernährung oder mangelndem Training.<br>
                Sie zerbrechen an Erwartungen, die nie ihre waren.</p>

                <h2>Wenn Hunde unsere Spiegel werden</h2>

                <p>Hunde fühlen uns - intensiver, als wir oft wahrhaben wollen.<br>
                Sie nehmen unsere Unruhe, unseren Druck, unsere Angst und unsere Trauer auf, lange bevor wir selbst merken, was in uns vorgeht.</p>

                <p>Ein unsicherer Mensch lebt selten mit einem souveränen Hund.<br>
                Nicht aus Pech, sondern aus Resonanz.</p>

                <p>Der Hund zeigt, was wir selbst überdecken: unsere Muster, unsere Themen, unser Ungleichgewicht.</p>

                <p>Doch statt hinzuschauen, beginnen viele dagegen anzutrainieren - Korrektur, Druck, ständige Optimierung.<br>
                Ein stiller Kreislauf aus Erwartung und Enttäuschung entsteht.</p>

                <h2>Projektion - wenn der Hund zur Ego-Verlängerung wird</h2>

                <p>Viele Menschen suchen im Hund das, was ihnen im Leben fehlt:<br>
                Sicherheit. Stärke. Erfolg. Anerkennung. Liebe.</p>

                <ul>
                <li>Der dominante Typ sucht Gehorsam.</li>
                <li>Der sensible Mensch sucht Harmonie.</li>
                <li>Der ehrgeizige Mensch sucht Perfektion.</li>
                </ul>

                <p>Doch ein Hund ist kein Werkzeug, kein Statussymbol und kein emotionaler Ersatz.<br>
                Er kann nicht tragen, was wir selbst nicht tragen wollen.</p>

                <p>Wenn Hunde plötzlich für unser inneres Chaos verantwortlich gemacht werden -<br>
                für unsere Wut, unseren Perfektionsdrang, unseren Selbstwert -<br>
                beginnt ihr Leiden.</p>

                <h2>Der unsichtbare Druck: „Sei ein braver Hund.“</h2>

                <p>„Er soll nicht bellen.“<br>
                „Er muss sich mit allen verstehen.“<br>
                „Er darf keine Fehler machen.“<br>
                „Er soll zeigen, dass ich es richtig mache.“</p>

                <p>Wie viele Hunde leben unter einem Leistungsdruck, den kein Lebewesen aushalten sollte?</p>

                <p>In einer Welt, die Perfektion feiert, wird sogar Hundeverhalten bewertet wie eine Kennzahl.<br>
                Was dabei verloren geht? <strong>Der Hund selbst.</strong></p>

                <p>Ein Hund, der immer funktionieren muss, verliert irgendwann seine Lebendigkeit.<br>
                Von außen perfekt, von innen leer.</p>

                <h2>Der „Vorzeigehund“-Mythos</h2>

                <p>Social Media verstärkt das Problem:<br>
                Perfekte Videos, perfekte Abläufe, perfekte Teams.</p>

                <p>Was wir sehen, ist selten Realität.<br>
                Es ist inszeniert, wiederholt, gefiltert - bis das Bild stimmt.</p>

                <p>Der Preis:</p>

                <ul>
                <li>Ein Hund, der gelernt hat, Emotionen zu unterdrücken.</li>
                <li>Ein Mensch, der sich selbst verliert.</li>
                <li>Eine Beziehung, die funktioniert - aber nicht fühlt.</li>
                </ul>

                <h2>Was Hunde wirklich brauchen</h2>

                <p>Nicht Perfektion.<br>
                Nicht Kontrolle.<br>
                Nicht ständige Aufmerksamkeit.</p>

                <p>Sondern Echtheit.</p>

                <p>Hunde brauchen Menschen, die sich selbst kennen.<br>
                Menschen, die bereit sind, nicht nur am Hund, sondern auch an sich selbst zu arbeiten.</p>

                <p>Denn ein klarer, authentischer Mensch gibt dem Hund Sicherheit, ohne Druck auszuüben.</p>

                <p>Wenn wir uns selbst verstehen, verändert sich der Hund automatisch.<br>
                Nicht, weil wir ihn formen -<br>
                sondern weil er in unserer Klarheit endlich Ruhe findet.</p>

                <h2>Der ehrliche Blick nach innen</h2>

                <p>Viele Hunde tragen Lasten, die nie ihre waren.<br>
                Sie werden zu stillen Therapeuten, zu emotionalen Stützen, zu Sinngebern für Menschen, die selbst keinen Halt finden.</p>

                <p>Doch kein Hund kann das auf Dauer leisten.<br>
                Tut er es doch, tut es ihm weh - leise oder deutlich.</p>

                <p>Wahre Hundeliebe beginnt nicht bei Opferbereitschaft, sondern bei Verantwortung:<br>
                Beim Mut, sich selbst anzuschauen.<br>
                Dort, wo es unangenehm wird.<br>
                Und dort, wo wir erkennen:<br>
                <strong>Der Hund ist nicht unser Werkzeug. Er ist unser Spiegel.</strong></p>

                <h2>Fazit</h2>

                <p>Ein „schwieriger“ Hund ist selten ein Problem.<br>
                Er ist eine Botschaft.</p>

                <p>Hunde spiegeln unsere Menschlichkeit - kompromisslos, ehrlich und ohne Maske.<br>
                Sie zeigen, was wir nicht hören wollen.<br>
                Und sie warten darauf, dass wir endlich zuhören.</p>

                <p>Echt.<br>
                Leise.<br>
                Demütig.</p>

                <p>Denn jeder Blick, jede Bewegung, jeder Atemzug spricht mit uns.</p>
        `,
        image: image2,
    },
    /* {
        id: 3,
        title: "Über Mich",
        date: "Januar 24, 2026",
        author: "Susanne",
        excerpt: "Die Liebe zu Tieren wurde mir sprichwörtlich in die Wiege gelegt.",
        content: `
                <p className="text-gray-800 leading-relaxed mb-6">
                    Die Liebe zu Tieren wurde mir sprichwörtlich in die Wiege gelegt. Bereits als kleines Mädchen war ich immer von Tieren umgeben – und das prägt einen für das ganze Leben. Mein treuester Begleiter in den ersten Jahren war ein wunderschöner Amerikanischer Collie Rüde in der seltenen Tricolor-Färbung namens „Prinz“.</p>
                    <p>Meine Kindheit verbrachte ich stets dort, wo Tiere waren: sei es auf dem Bauernhof der Nachbarn, im Pferdestall einer Freundin meiner Mutter, im Wildtierpark oder sogar bei den Maikäfern, die vom Kirschbaum in unserem Garten fielen.</p>
                    <p>1988 zog ich in meine erste eigene Wohnung, begleitet von zwei Katzen. Mein Traum von einem Hund wurde 1997 wahr: Eine Mischlingshündin namens Sally kam in mein Leben.</p>
                    <p>Später folgten „Charly“, der Border Collie, und „Joy“, die Australian Cattle Dog Hündin meines Ex-Manns. 2010 begann ich unter dem Zwingernamen „Chocolate Chips“ Britisch Kurzhaar Katzen zu züchten.</p>
                    <p>Milo, ein Mix aus Boxer und Old English Bulldog, war mein Seelenhund. Er begleitete mich durch alle Höhen und Tiefen des Lebens. 2021 musste ich mich von Minnie verabschieden. Kurz danach zog Mabel, eine Amerikanische Collie Hündin, ein, und 2023 folgte Mathilda.</p>
                    <p>Am 23. Februar 2024 musste ich mich von Milo verabschieden. Sein Verlust hinterlässt eine riesige Lücke, doch die Erinnerung an ihn und all die wundervollen Tiere bleibt für immer.</p>
                    </div>
        `,
        image: image3,
    }, */
];

const Blog = () => {

    const [showModal, setShowModal] = useState(false);

    const toggleModal = () => setShowModal(prev => !prev);

    const [expandedPost, setExpandedPost] = useState(null);

    const togglePost = (id) => {
        setExpandedPost(expandedPost === id ? null : id);

    };

    return (
        <div>
            <Header onContactClick={toggleModal} />
            <section className="blog">
                <h2>Letzte Posts</h2>
                <div className="blog-grid">
                    {blogPosts.map((post) => {
                        const isExpanded = expandedPost === post.id;

                        return (
                            <article
                                key={post.id}
                                className={`blog-card ${isExpanded ? "expanded" : ""}`}
                                onClick={() => togglePost(post.id)}
                            >
                                <img
                                    src={post.image}
                                    alt={post.title}
                                    className="blog-image"
                                />
                                <div className="blog-meta">
                                    <time>{post.date}</time>
                                    <span>by {post.author}</span>
                                </div>
                                <h3>{post.title}</h3>
                                <div
                                    className="blog-content"
                                    dangerouslySetInnerHTML={{
                                        __html: isExpanded ? post.content : post.excerpt,
                                    }}
                                />
                                <button
                                    className="toggle-button"
                                    onClick={(e) => {
                                        e.stopPropagation();
                                        togglePost(post.id);
                                    }}
                                >
                                    {isExpanded ? "Zeige weniger" : "Mehr Infos"}
                                </button>
                            </article>
                        );
                    })}
                </div>
            </section>
            <ContactModal show={showModal} onClose={toggleModal} />
        </div>
    );
};

export default Blog;